import PropTypes from "prop-types";
import "./styles.scss";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";

const LoadingDots = ({ size, color, id, index }) => {
  const { buttons } = useInitialConfigStore.getState((state) => state).theme;

  let classSize = "";

  if (size === "small") {
    classSize = "loading-dots--small";
  } else if (size === "medium") {
    classSize = "loading-dots--medium";
  } else if (size === "large") {
    classSize = "loading-dots--large";
  }

  return (
    <div
      id={id}
      data-testid={`loading-dots-${index}`}
      className={`loading-dots ${classSize} ${
        color === "primary"
          ? "loading-dots--color-primary"
          : "loading-dots--color-white"
      }`}
      style={{
        background:
          color === "primary"
            ? `radial-gradient(circle closest-side, ${buttons.backgroundColor} 90%, #007bff00) 0 / calc(100% / 3) 100% space`
            : undefined,
      }}
    />
  );
};

LoadingDots.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]).isRequired,
  color: PropTypes.string.isRequired,
  id: PropTypes.string,
  index: PropTypes.number,
};

export default LoadingDots;
